/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RouteTypeEnum } from './routeTypeEnum';
import { ServerTypeEnum } from './serverTypeEnum';


export interface SmsRouteDto { 
    creatorId?: string;
    isOwnedByCoure: boolean;
    operatorCode?: string;
    routeCanBeUsedForMultipleOperators: boolean;
    publicName?: string;
    smsRouteName?: string;
    description?: string;
    serverType: ServerTypeEnum;
    serverTypeEnumName?: string;
    active: boolean;
    dateCreated: Date;
    routeType: RouteTypeEnum;
    routeTypeName?: string;
    operatorId: number;
    groupIdentifier?: string;
}
